const strings = {
  TOKEN_INFORMATION: 'TOKEN_INFORMATION',
  APP_THEME: 'APP_THEME',
  APP_LANGUAGE: 'APP_LANGUAGE',
  CACHE_LANGUAGES: 'APP_LANGUAGES',
  LAST_SELECTED_COUNTRY_ID: 'LAST_SELECTED_COUNTRY_ID',
};
export default strings;
